<template>
  <el-dialog
      :title="setId?'编辑账户':'新增账户'"
      :visible.sync="accountDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="accountForm.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="accountForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="初始密码">
        <el-input value="123456" disabled></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="desc">
        <el-input type="textarea" v-model="accountForm.desc"></el-input>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('accountForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {userAdd} from "@/api/admin";
export default {
  name: "accountDialog",
  props: {
    accountDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[0-9]{10}$/;
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      }
      setTimeout(() => {

        if (!Number.isInteger(+value)) {
          callback(new Error('手机号码不能为空'))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('手机号码格式不正确'))
          }
        }
      }, 100)
    };
    return {
      accountForm: {
        name: '',
        phone: '',
        desc: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        phone: [
          {required: true, validator: checkPhone, trigger: 'blur'}
        ]
      }
    }
  },
  methods:{
    resetForm(formName){
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog',false)
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await userAdd(
          this.accountForm.name,
          this.accountForm.phone,
          this.accountForm.desc,
          this.setId?this.setId:'',
      );
      this.$message.success(_state.msg);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {
    setItem() {
      this.accountForm = {
        name: this.setItem.admin_name,
        phone: this.setItem.admin_phone,
        desc: this.setItem.remark
      };
    }
  }
}
</script>

<style scoped lang="scss">

</style>